import {useSelector} from 'react-redux';

import {
    getCurrentShippingAddress,
    getOrderDataForRequestForMentionMe,
} from 'desktop/selectors/mentionMe/mentionMe';
import {useGetCustomerData} from 'hooks/getCustomerData/getCustomerData';

/**
 * Hook for getting data for request mention me
 */
export const useGetDataForRequestMentionMe = (key: string) => {
    const {email, firstname, lastname: surname, status} = useGetCustomerData();
    const {
        email: {value: emailCustomer = ''},
        firstName: {value: firstNameCustomer = ''},
        lastName: {value: lastNameCustomer = ''},
    } = useSelector(getCurrentShippingAddress);

    const orderData = useSelector(getOrderDataForRequestForMentionMe);

    const userData = {
        email: email || emailCustomer,
        firstname: firstname || firstNameCustomer,
        isFulfilled: status?.toLowerCase() === 'fulfilled',
        surname: surname || lastNameCustomer,
    };

    const data = {
        dashboard: userData,
        landingpage: userData,
        postpurchase: {...userData, ...orderData},
        refereefind: {},
    };

    return data[key as 'postpurchase' | 'dashboard'];
};
